import Model from 'flarum/common/Model';
export default class Levels extends Model {
  name = Model.attribute('name');
  min_exp_required = Model.attribute('min_exp_required');
}
flarum.reg.add('foskym-custom-levels', 'common/models/Levels', Levels);